import React, { useState } from "react";

export default function InviteOnboarding({ onChoose, onClose }) {
  const [step, setStep] = useState("welcome"); // "welcome" | "choose"

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
      background: "rgba(0,0,0,0.97)", display: "flex", alignItems: "center",
      justifyContent: "center", zIndex: 8000, 
      padding: "20px",
      paddingBottom: "calc(20px + env(safe-area-inset-bottom))", // ✅ iOS Safe Area
      boxSizing: "border-box",  // ✅ padding wird eingerechnet
      overflowY: "auto"         // ✅ scrollbar falls Screen zu klein
    }}>
      <div style={{
        background: "#0d1117", borderRadius: "24px", width: "100%",
        maxWidth: "420px", border: "1px solid #00acc1", overflow: "hidden",
        boxSizing: "border-box",  // ✅ 
        margin: "auto"            // ✅ zentriert auch beim Scrollen
      }}>
        
        {/* HEADER BANNER */}
        <div style={{
          background: "linear-gradient(135deg, #00acc1, #006064)",
          padding: "30px 25px", textAlign: "center", position: "relative"
        }}>
          {/* ✅ NEU: Close Button */}
            <button
              onClick={onClose}
              style={{
                position: "absolute", top: "12px", right: "12px",
                background: "none", border: "none", color: "rgba(255,255,255,0.6)",
                fontSize: "1.2rem", cursor: "pointer", lineHeight: 1
              }}
            >
              ✕
            </button>
          <img src="/streetwise-radio-logo.png" style={{ width: "40px", marginBottom: "12px" }} alt="Logo" />
          <div style={{ fontSize: "0.7rem", letterSpacing: "4px", color: "rgba(255,255,255,0.7)", marginBottom: "4px" }}>
            WELCOME TO
          </div>
          <h1 style={{ margin: 0, fontSize: "1.4rem", fontWeight: "900", color: "#fff", letterSpacing: "2px" }}>
            STREETWISE RADIO
          </h1>
          <div style={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.8)", marginTop: "4px" }}>
            COLLECTIVE STUDIO
          </div>
        </div>

        <div style={{ padding: "25px" }}>
          {step === "welcome" && (
            <>
              <p style={{ color: "#ccc", fontSize: "1rem", lineHeight: "1.6", marginBottom: "25px", textAlign: "center" }}>
                Möchtest bei unserem COLLECTIVE Radio Studio mitwirken? 
                Wähle wie du mitmachen möchtest:
              </p>

              {/* OPTION: SELECTOR */}
              <div
                onClick={() => onChoose("selector")}
                style={{
                  padding: "18px", background: "rgba(255,255,255,0.04)",
                  border: "1px solid #222", borderRadius: "14px",
                  cursor: "pointer", marginBottom: "12px",
                  transition: "border-color 0.2s"
                }}
                onMouseEnter={e => e.currentTarget.style.borderColor = "#00acc1"}
                onMouseLeave={e => e.currentTarget.style.borderColor = "#222"}
              >
                <div style={{ fontSize: "1.4rem", marginBottom: "6px" }}>🎧</div>
                <div style={{ fontWeight: "900", fontSize: "0.85rem", color: "#fff", letterSpacing: "1px" }}>
                  SELECTOR
                </div>
                <div style={{ fontSize: "0.9rem", color: "#666", marginTop: "4px", lineHeight: "1.4" }}>
                  Alle Tracks anhören, Redaktion & Community – ohne Upload eigener Tracks.
                </div>
              </div>

              {/* OPTION: ARTIST */}
              <div
                onClick={() => onChoose("artist")}
                style={{
                  padding: "18px", background: "rgba(0,172,193,0.07)",
                  border: "1px solid #00acc1", borderRadius: "14px",
                  cursor: "pointer", marginBottom: "25px"
                }}
              >
                <div style={{ fontSize: "1.4rem", marginBottom: "6px" }}>🎙️</div>
                <div style={{ fontWeight: "900", fontSize: "0.85rem", color: "#00acc1", letterSpacing: "1px" }}>
                  ARTIST
                </div>
                <div style={{ fontSize: "0.9rem", color: "#888", marginTop: "4px", lineHeight: "1.4" }}>
                  Eigene MP3 Tracks uploaden, Profil anlegen & im Radio präsent sein.
                </div>
              </div>

              <button
                onClick={onClose}
                style={{ width: "100%", background: "none", border: "none", color: "#444", fontSize: "0.9rem", cursor: "pointer" }}
              >
                Ohne Login — nur Public Selection anhören
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}